import React, { Component } from 'react';
import { GenericEditPanel, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import CodigoGeografico from "./CodigoGeografico";

class Domicilio extends Component {

    constructor(props) {
        super(props);

        this.actualizarNovedadEstados = this.actualizarNovedadEstados.bind(this);
        this.armarDescripcionDomicilio = this.armarDescripcionDomicilio.bind(this);
        this.selectCombo = this.selectCombo.bind(this);
        this.guardarNovedades = this.guardarNovedades.bind(this);
    }

    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstados(novedades, estadoId, entidadId) {
        this.props.actualizarNovedadEstados(novedades, estadoId, novedades[0].NovedadTipoId, entidadId)
    }

    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        let index = event.target.selectedIndex;
        let optionActual = event.target.options[index].dataset.codigo;
        this.props.selectCombo(0, this.props.codigoNovedad, event.target.value, optionActual);
    }

    /**
     * 
     */
    guardarNovedades() {

        let novedades = [
            { 'Id': undefined, 'Clave': 'DMBCO_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioBancoTipo, 'ValorNuevo': this.props.data.empresaDatos.DomicilioBancoTipo },
            { 'Id': undefined, 'Clave': 'DMCAL_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioCalle, 'ValorNuevo': this.props.data.empresaDatos.DomicilioCalle },
            { 'Id': undefined, 'Clave': 'DMNRO_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioNumero, 'ValorNuevo': this.props.data.empresaDatos.DomicilioNumero },
            { 'Id': undefined, 'Clave': 'DMDPT_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioDepartamentoPartido, 'ValorNuevo': this.props.data.empresaDatos.DomicilioDepartamentoPartido },
            { 'Id': undefined, 'Clave': 'DMLOD_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioLod, 'ValorNuevo': this.props.data.empresaDatos.DomicilioLod },
            { 'Id': undefined, 'Clave': 'DMCOP_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioCodigoPostal, 'ValorNuevo': this.props.data.empresaDatos.DomicilioCodigoPostal },
            { 'Id': undefined, 'Clave': 'DMCGE_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.DomicilioCodigoGeografico, 'ValorNuevo': this.props.data.empresaDatos.DomicilioCodigoGeografico != "0" ? this.props.data.empresaDatos.DomicilioCodigoGeografico : this.props.data.empresaDatos.DomicilioCodigoGeograficoInput },
            { 'Id': undefined, 'Clave': 'DMCAR_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.Caracteristica, 'ValorNuevo': this.props.data.empresaDatos.Caracteristica },
            { 'Id': undefined, 'Clave': 'DMTEL_EMPR', 'ValorAnterior': this.props.data.empresaDatosOriginal.Telefono, 'ValorNuevo': this.props.data.empresaDatos.Telefono },
        ];

        this.props.guardarNovedades(novedades);
    }

    /**
     * 
     * @param {any} cadenaOriginal
     * @param {any} codigoNovedad
     * @param {any} valorNovedad
     * @param {any} tieneFormato
     */
    armarDescripcionDomicilio(cadenaOriginal, codigoNovedad, valorNovedad, tieneFormato) {
        let formato = "#DMBCO_EMPR#, #DMCAL_EMPR#, #DMNRO_EMPR#, #DMDPT_EMPR#, #DMLOD_EMPR#, #DMCOP_EMPR#, (Cód. geográfico #DMCGE_EMPR#). (Telefono #DMCAR_EMPR# #DMTEL_EMPR#)";
        
        if (valorNovedad == undefined || valorNovedad == null) {
            valorNovedad = "";
        }

        if (tieneFormato) {
            return cadenaOriginal.replace(`#${codigoNovedad}#`, valorNovedad);
        }
        else {
            return formato.replace(`#${codigoNovedad}#`, valorNovedad);
        }
    }

    /**
     * 
     */
    render() {

        const { props, armarDescripcionDomicilio } = this;
        const { domiciliosService, empresaDatos, empresaDatosOriginal, mostrarCodigoGeografico, novedadesEmpresaDatos, seEstaEditando } = props.data;
        const ValorDomicilioCodigoGeograficoEmpresa = ((empresaDatosOriginal.DomicilioCodigoGeografico != "0")
            ? empresaDatosOriginal.DomicilioCodigoGeografico
            : empresaDatosOriginal.DomicilioCodigoGeograficoInput);

        const campoValorNovedad = [
            { Codigo: "DMBCO_EMPR", Valor: empresaDatosOriginal.DomicilioBancoTipo },
            { Codigo: "DMCAL_EMPR", Valor: empresaDatosOriginal.DomicilioCalle },
            { Codigo: "DMNRO_EMPR", Valor: empresaDatosOriginal.DomicilioNumero },
            { Codigo: "DMDPT_EMPR", Valor: empresaDatosOriginal.DomicilioDepartamentoPartido },
            { Codigo: "DMLOD_EMPR", Valor: empresaDatosOriginal.DomicilioLod },
            { Codigo: "DMCOP_EMPR", Valor: empresaDatosOriginal.DomicilioCodigoPostal },
            { Codigo: "DMCGE_EMPR", Valor: ValorDomicilioCodigoGeograficoEmpresa },
            { Codigo: "DMCAR_EMPR", Valor: empresaDatosOriginal.Caracteristica },
            { Codigo: "DMTEL_EMPR", Valor: empresaDatosOriginal.Telefono }
        ];

        /*genero un array con los codigo unicamente de las novedades de domicilio*/
        const codigosNovedad = campoValorNovedad.map((cn) => cn.Codigo);

        /*filtro solamente por las novedades del domicilio*/
        const novedadesDomicilio = novedadesEmpresaDatos.filter((novedad) => codigosNovedad.some((cn) => cn == novedad.NovedadCampoCodigo));

        let novedadDomicilio = undefined;
        let novedadCodGeografico = undefined;
        let descripcionDomicilio = "";
        let descripcionDomicilioValorAnterior = "";
        let domicilios = undefined;
        let domicilioSeleccionado = undefined;
        let optionsDomicilios = [];
                
        campoValorNovedad.forEach((cvn, index) => {
            descripcionDomicilio = armarDescripcionDomicilio(descripcionDomicilio, cvn.Codigo, cvn.Valor, (index > 0));
        });
        
        // Novedad en Domicilio
        if (novedadesDomicilio && novedadesDomicilio.length > 0) {

            novedadesDomicilio.forEach((nov2, index) => {
                descripcionDomicilio = armarDescripcionDomicilio(descripcionDomicilio, nov2.NovedadCampoCodigo, nov2.ValorNovedad, (index > 0))
                descripcionDomicilioValorAnterior = armarDescripcionDomicilio(descripcionDomicilioValorAnterior, nov2.NovedadCampoCodigo, nov2.ValorAnterior, (index > 0))
            });

            /* Hago copia de la novedad codigo geografico para construir otra con las demas. */
            novedadDomicilio = JSON.parse(JSON.stringify(novedadesDomicilio.find((nd) => nd.NovedadCampoCodigo == "DMCGE_EMPR")));
            novedadDomicilio.ValorNovedad = descripcionDomicilio;
            novedadDomicilio.ValorAnterior = descripcionDomicilioValorAnterior;

            /* Hago otra copia de la novedad de codigo geografico para el mismo*/
            novedadCodGeografico = JSON.parse(JSON.stringify(novedadesDomicilio.find((nd) => nd.NovedadCampoCodigo == "DMCGE_EMPR")));
        }

        if (domiciliosService) {
            domicilioSeleccionado = domiciliosService.find((domicilio) => domicilio.CodigoDomicilio == empresaDatos.DomicilioBancoTipo);
        }

        optionsDomicilios.push(
            <option value={0} key={"BonificacionOp_" + 0} selected="selected" >
                {descripcionDomicilio}
            </option >
        );

        if (domiciliosService) {
            domiciliosService.map((ds, index) => {

                const descripcionSer = (ds.codigoDomicilio) ?
                    ds.CodigoDomicilio + " - "
                    + ds.Calle + ', '
                    + ds.Numero + ', '
                    + ds.Localidad + ', '
                    + ds.CodigoPostal + '. (Telefono: ' + (ds.Telefono.Caracteristica != "" ? ds.Telefono.Caracteristica + '-' : "")
                    + ds.Telefono.Numero + ')' : ds.Calle;
                
                optionsDomicilios.push(
                    <option value={index} data-codigo={ds.codigoDomicilio} key={"BonificacionOp_" + index}>
                        {descripcionSer}
                    </option>
                );
            });
        }
        else {
            optionsDomicilios.push(
                <option key={"BonificacionOp_" + 1}>
                    FALLO WEBSERVICE
                </option>
            );
        }

        const huboError = ((props.data.empresaDatos.DomicilioCodigoGeografico == "0"
            && (props.data.empresaDatos.DomicilioCodigoGeograficoInput == "" || props.data.empresaDatos.DomicilioCodigoGeograficoInput == undefined))
            || (props.data.empresaDatos.DomicilioCodigoGeografico == "" || props.data.empresaDatos.DomicilioCodigoGeografico == undefined));

        const selectDomicilio = (
            <div>
                <GenericSelect id="selDomicilios" className="form-control default-select bottom-separator-xs error"
                    options={optionsDomicilios} onChange={this.selectCombo} />

                {domicilioSeleccionado &&
                    <CodigoGeografico data={props.data} form={props.form} error={huboError} domicilio={domicilioSeleccionado}
                        novedad={novedadCodGeografico}
                        guardarCampo={props.guardarCampo} />}
            </div>
        );

        return (
            <GenericEditPanel
                componente={selectDomicilio}
                error={huboError}
                permisoUsuario={props.data.funcionesDelUsuario}
                novedad={novedadDomicilio}
                seEstaEditando={seEstaEditando}
                textPanel={descripcionDomicilio}
                title="Domicilio"
                value={descripcionDomicilio}

                aceptChanges={this.guardarNovedades}
                confirmarNovedad={() => this.actualizarNovedadEstados(novedadesDomicilio, 2, props.data.empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstados(novedadesDomicilio, 3, props.data.empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default Domicilio;